import { render, staticRenderFns } from "./ClassDescriptions.vue?vue&type=template&id=23b70a2e&scoped=true"
import script from "./ClassDescriptions.vue?vue&type=script&lang=js"
export * from "./ClassDescriptions.vue?vue&type=script&lang=js"
import style0 from "./ClassDescriptions.vue?vue&type=style&index=0&id=23b70a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b70a2e",
  null
  
)

export default component.exports